// import { useEffect, useRef, useState } from "react";
// import schoolApi from "../../api/schoolApi";

// import { Helmet } from "react-helmet";
// import { Button, Col, Form, Row, Table } from "react-bootstrap";
// import { Link } from "react-router-dom";
// import PrintTeacherTimetable from "./print_teacher_timetable";
// import PrintClassTimeTable from "./print_class_timetable";
// import jsPDF from "jspdf";
// import "jspdf-autotable";

// export default function NewPrintTimeTable(props) {
//   let [teacherList, setTeacherList] = useState([]);
//   let [classList, setClassList] = useState([]);
//   let [classTimeTable, setClassTimeTable] = useState([]);
//   let [teacherId, setTeacherId] = useState("");
//   let [sectionId, setSectionId] = useState("");
//   let [classId, setClassId] = useState("");
//   let [teacher, setTeacher] = useState(null);
//   let [view, setView] = useState(null);
//   let tableRef = useRef(null);

//   useEffect(() => {

//     try {
//       async function getTeachers() {
//         let category = null;
//         const result = await schoolApi.getTeacherRecords(category); //.then((result) => {

//         if (result?.teacherData) {
//           setTeacherList(result?.teacherData);
//         }
//       }

//       async function getClass() {
//         let catgory = null;
//         const classList = await schoolApi.getClassRecordsWithSections(catgory);

//         setClassList(classList?.data);
//       }

//       getClass();
//       getTeachers();
//     } catch (error) {

//     }
//   }, []);

//   useEffect(() => {

//   }, [teacher]);

//   function onChangeTeacher(event) {
//     const selectedTeacherId = event.target.value;

//     const selectedTeacher = teacherList.find(
//       (teacher) => teacher.id === selectedTeacherId
//     );

//     setTeacher(selectedTeacher);
//     if (selectedTeacher) {
//       setView("teacher");
//     } else {
//       setView("");
//     }

//     setTeacherId(selectedTeacherId);
//     setSectionId("");
//   }

//   function onChangeClass(event) {
//     const selectedSectionId = event.target.value;

//     const selectedClass = classList.find(
//       (cls) => cls.section_id === selectedSectionId
//     );

//     setSectionId(selectedSectionId);

//     if (selectedClass) {
//       setClassId(selectedClass.class_id);
//     } else {
//       setClassId("");
//       setView("");
//     }
//     setTeacherId("");
//     setTeacher(null);
//   }

//   const fetchTimetable = async () => {
//     try {
//       let timetableResult = await schoolApi.fetchTimetableRecords(
//         classId,
//         sectionId
//       );

//       if (timetableResult && timetableResult.success === true) {
//         setClassTimeTable(timetableResult);
//         setView("class");
//       } else {
//         setClassTimeTable([]);
//         setView("");
//       }
//     } catch (error) {

//     }
//   };

//   useEffect(() => {
//     if (classId && sectionId) {
//       fetchTimetable();
//     }
//   }, [sectionId]);

//   const onDownloadPDF = () => {
//     console.log("onDownloadPDF");
//     console.log("tableRef.current", tableRef.current);

//     const doc = new jsPDF({
//       orientation: "landscape",
//       unit: "mm",
//       format: "a4",
//     });

//     doc.setFillColor("#F4F7FA");
//     doc.rect(0, 0, doc.internal.pageSize.width, doc.internal.pageSize.height, "F");

//     doc.setFontSize(12);
//     doc.text("Time Table", 130, 15);

//     doc.autoTable({
//       html: tableRef.current,
//       startY: 20,
//       styles: {
//         halign: "center",
//         valign: "middle",
//         textColor: "#000000",
//         lineColor: "#DEE2E6",
//         lineWidth: 0.2,
//       },
//       headStyles: {
//         fillColor: "#FFFFFF",
//         textColor: "#000000",
//       },
//       bodyStyles: {
//         fillColor: "#FFFFFF",
//       },
//       didParseCell: function (data) {
//         if (data.cell.raw) {
//           const teacherDiv = data.cell.raw.querySelector('div[name="teacher"]');
//           const subjectDiv = data.cell.raw.querySelector('div[name="subject"]');

//           if (teacherDiv && subjectDiv) {
//             data.cell.text = [`${teacherDiv.innerText}`, "", `${subjectDiv.innerText}`];
//           }

//           if (!teacherDiv && !subjectDiv) {
//             const firstDiv = data.cell.raw.children[0];
//             const secondDiv = data.cell.raw.children[1];

//             if (firstDiv && secondDiv) {
//               data.cell.text = [`${firstDiv.innerText}`, "", `${secondDiv.innerText}`];
//             }
//           }
//           data.cell.styles.cellPadding = { top: 5, bottom: 5 };
//         }

//         // Lunch Time Style
//         if (data.cell.raw && data.cell.raw.innerText === "Lunch Time") {
//           data.cell.styles.halign = "center";
//           data.cell.styles.valign = "middle";
//           data.cell.styles.fontStyle = "bold";
//           data.cell.styles.cellPadding = { top: 5, bottom: 5 };
//           data.cell.styles.fillColor = "#FFFFFF";
//         } else {
//           data.cell.styles.fillColor = "#FFFFFF";
//         }
//       }
//     });

//     doc.save("timetable-1.pdf");
//   };

//   return (
//     <>
//       <Helmet>
//         <title>{props.tabName}</title>
//       </Helmet>
//       <Row className="g-0">
//         <Row>
//           <Col lg={10} className="mx-4">
//             <Link className="nav-link" to="/">
//               Home <i className="fa-solid fa-chevron-right"></i>TimeTable
//             </Link>
//           </Col>
//         </Row>
//         <Row>
//           <Col lg={4} className="mx-2 p-4" id="tabledata">
//             {classList && classList.length > 0 ? (
//               <Form.Group>
//                 <Form.Label
//                   className="form-view-label"
//                   htmlFor="formBasicClass"
//                 >
//                   Class Name
//                 </Form.Label>
//                 <Form.Select
//                   name="section_id"
//                   value={sectionId}
//                   onChange={onChangeClass}
//                 >
//                   <option value="">-Select Class-</option>
//                   {classList.map((cls, index) => (
//                     <option key={index} value={cls.section_id}>
//                       {cls.classname}
//                     </option>
//                   ))}
//                 </Form.Select>
//               </Form.Group>
//             ) : (
//               <>
//                 <Form.Group>
//                   <Form.Label
//                     className="form-view-label"
//                     htmlFor="formBasicClass"
//                   >
//                     Class Name
//                   </Form.Label>
//                   <Form.Select
//                     name="section_id"
//                     value={sectionId}
//                     onChange={onChangeClass}
//                   >
//                     <option value="">-Select Class-</option>
//                     {classList?.map((cls, index) => (
//                       <option key={index} value={cls.section_id}>
//                         {cls.classname}
//                       </option>
//                     ))}
//                   </Form.Select>
//                 </Form.Group>
//               </>
//             )}
//           </Col>
//           <Col lg={4} className="mx-2 p-4">
//             {teacherList && teacherList.length > 0 ? (
//               <Form.Group>
//                 <Form.Label
//                   className="form-view-label"
//                   htmlFor="formBasicClass"
//                 >
//                   Teacher Name
//                 </Form.Label>
//                 <Form.Select
//                   name="teacher_id"
//                   value={teacherId}
//                   onChange={onChangeTeacher}
//                 >
//                   <option value="">-Select Teacher-</option>
//                   {teacherList.map((teacher, index) => (
//                     <option key={index} value={teacher.id}>
//                       {teacher.teachername}
//                     </option>
//                   ))}
//                 </Form.Select>
//               </Form.Group>
//             ) : (
//               <>
//                 <Form.Group>
//                   <Form.Label
//                     className="form-view-label"
//                     htmlFor="formBasicClass"
//                   >
//                     Teacher Name
//                   </Form.Label>
//                   <Form.Select
//                     name="teacher_id"
//                     value={teacherId}
//                     onChange={onChangeTeacher}
//                   >
//                     <option value="">-Select Teacher-</option>
//                     {teacherList.map((teacher, index) => (
//                       <option key={index} value={teacher.id}>
//                         {teacher.teachername}
//                       </option>
//                     ))}
//                   </Form.Select>
//                 </Form.Group>
//               </>
//             )}
//           </Col>
//         {(teacherId || classId) && (
//             <Col lg={3} className="mx-2 mt-5" style={{ textAlign: "right" }}>
//               <Button className="mx-2" onClick={onDownloadPDF}>
//                 Download
//               </Button>
//             </Col>
//           )}
//         </Row>

//         <Row>
//           <Col className="mx-4">
//             <div>
//               {view === "teacher" ? (
//                 teacher ? (
//                   <PrintTeacherTimetable
//                     teacher={teacher}
//                     tableRef={tableRef}
//                   />
//                 ) : (
//                   <>No Teacher Data Found!</>
//                 )
//               ) : view === "class" ? (
//                 classTimeTable ? (
//                   <PrintClassTimeTable
//                     timeTableSlots={classTimeTable.timeSlotsResult}
//                     tableRef={tableRef}
//                   />
//                 ) : (
//                   <>No Class Data Found!</>
//                 )
//               ) : (
//                 <></>
//               )}
//             </div>
//           </Col>
//         </Row>
//       </Row>
//     </>
//   );
// }

import { useEffect, useRef, useState } from "react";
import schoolApi from "../../api/schoolApi";

import { Helmet } from "react-helmet";
import { Button, Col, Form, Row, Table } from "react-bootstrap";
import { Link } from "react-router-dom";
import PrintTeacherTimetable from "./print_teacher_timetable";
import PrintClassTimeTable from "./print_class_timetable";
import jsPDF from "jspdf";
import "jspdf-autotable";

export default function NewPrintTimeTable(props) {
  let [teacherList, setTeacherList] = useState([]);
  let [classList, setClassList] = useState([]);
  let [classTimeTable, setClassTimeTable] = useState([]);
  let [teacherId, setTeacherId] = useState("");
  let [sectionId, setSectionId] = useState("");
  let [classId, setClassId] = useState("");
  let [teacher, setTeacher] = useState(null);
  let [view, setView] = useState(null);
  let tableRef = useRef(null);

  useEffect(() => {
    try {
      async function getTeachers() {
        let category = null;
        const result = await schoolApi.getTeacherRecords(category); //.then((result) => {

        if (result?.teacherData) {
          setTeacherList(result?.teacherData);
        }
      }

      async function getClass() {
        let catgory = null;
        const classList = await schoolApi.getClassRecordsWithSections(catgory);

        setClassList(classList?.data);
      }

      getClass();
      getTeachers();
    } catch (error) {}
  }, []);

  useEffect(() => {}, [teacher]);

  function onChangeTeacher(event) {
    const selectedTeacherId = event.target.value;

    const selectedTeacher = teacherList.find(
      (teacher) => teacher.id === selectedTeacherId
    );
    console.log("selected teacher:", selectedTeacher);

    setTeacher(selectedTeacher);
    if (selectedTeacher) {
      setView("teacher");
    } else {
      setView("");
    }

    setTeacherId(selectedTeacherId);
    setSectionId("");
  }

  function onChangeClass(event) {
    const selectedSectionId = event.target.value;

    const selectedClass = classList.find(
      (cls) => cls.section_id === selectedSectionId
    );

    setSectionId(selectedSectionId);

    if (selectedClass) {
      setClassId(selectedClass.class_id);
    } else {
      setClassId("");
      setView("");
    }
    setTeacherId("");
    setTeacher(null);
  }

  const fetchTimetable = async () => {
    try {
      let timetableResult = await schoolApi.fetchTimetableRecords(
        classId,
        sectionId
      );

      if (timetableResult && timetableResult.success === true) {
        setClassTimeTable(timetableResult);
        setView("class");
      } else {
        setClassTimeTable([]);
        setView("");
      }
    } catch (error) {}
  };

  useEffect(() => {
    if (classId && sectionId) {
      fetchTimetable();
    }
  }, [sectionId]);

  // const onDownloadPDF = () => {
  //   console.log("onDownloadPDF")
  //   console.log("tableRef.current", tableRef.current);
  //   const doc = new jsPDF({
  //     orientation: "landscape",
  //     unit: "mm",
  //     format: "a4",
  //   });

  //   doc.setFillColor("#F4F7FA"); // Light Grayish Blue
  //   doc.rect(0, 0, doc.internal.pageSize.width, doc.internal.pageSize.height, "F");

  //   doc.setFontSize(12);

  //   doc.text("Time Table", 130, 15);

  //   doc.autoTable({
  //     html: tableRef.current,
  //     startY: 20,
  //     styles: {
  //       halign: "center",
  //       valign: "middle",
  //       textColor: "#000000",
  //       lineColor: "#DEE2E6", // Border color (Black)
  //       lineWidth: 0.2, // Border width
  //     },
  //     headStyles: {
  //       fillColor: "#FFFFFF",
  //       textColor: "#000000", 
  //     },
  //     bodyStyles: {
  //       fillColor: "#FFFFFF",
  //       // textColor: "#000000",
  //     },
  //     didParseCell: function (data) {
  //       console.log("data == ",data)
  //       console.log("data table == ",data.table.body[0].row)

  //       if (data.cell.raw && data.cell.raw.innerText === "Lunch Time") {
  //         data.cell.styles.halign = "center";
  //         data.cell.styles.valign = "middle";
  //         data.cell.styles.fontStyle = "bold";
  //         data.cell.styles.cellPadding = { top: 7, bottom: 7 };
  //         data.cell.styles.fillColor = "#FFFFFF"; // White background
  //       } else {
  //         data.cell.styles.fillColor = "#FFFFFF"; // Light gray for other cells
  //       }
  //     }
  //   });

  //   doc.save("timetable-1.pdf");
  // };

  const onDownloadPDF = () => {
    const doc = new jsPDF({
      orientation: "landscape",
      unit: "mm",
      format: "a4",
    });

    doc.setFillColor("#F4F7FA"); // Light Grayish Blue
    doc.rect(
      0,
      0,
      doc.internal.pageSize.width,
      doc.internal.pageSize.height,
      "F"
    );

    doc.setFontSize(12);

    doc.text("Time Table", 130, 15);

    doc.autoTable({
      html: tableRef.current,
      startY: 20,
      styles: {
        halign: "center",
        valign: "middle",
        textColor: "#000000",
        lineColor: "#DEE2E6", // Border color (Black)
        lineWidth: 0.2, // Border width
      },
      headStyles: {
        fillColor: "#FFFFFF",
        textColor: "#000000",
      },
      bodyStyles: {
        fillColor: "#FFFFFF",
        // textColor: "#000000",
      },
      didParseCell: function (data) {
        if (data.cell.raw) {
          const teacherDiv = data.cell.raw.querySelector('div[name="teacher"]');
          const subjectDiv = data.cell.raw.querySelector('div[name="subject"]');
  
          if (teacherDiv && subjectDiv) {
            data.cell.text = [`${teacherDiv.innerText}`, "", `${subjectDiv.innerText}`];
          }
        
          // if (!teacherDiv && !subjectDiv) {
          //   const firstDiv = data.cell.raw.children[0];
          //   const secondDiv = data.cell.raw.children[1];
    
          //   if (firstDiv && secondDiv) {
          //     data.cell.text = [`${firstDiv.innerText}`, "", `${secondDiv.innerText}`];
          //   }
          // }
          data.cell.styles.cellPadding = { top: 5, bottom: 5 };
        }
  
        // Lunch Time Style
        if (data.cell.raw && data.cell.raw.innerText === "Lunch Time") {
          data.cell.styles.halign = "center";
          data.cell.styles.valign = "middle";
          data.cell.styles.fontStyle = "bold";
          data.cell.styles.cellPadding = { top: 7, bottom: 7 };
          data.cell.styles.fillColor = "#FFFFFF"; // White background
        } else {
          data.cell.styles.fillColor = "#FFFFFF"; // Light gray for other cells
        }
      },
    });

    doc.save("timetable-1.pdf");
  };
  
  
  return (
    <>
      <Helmet>
        <title>{props.tabName}</title>
      </Helmet>
      <Row className="g-0">
        <Row>
          <Col lg={10} className="mx-4">
            <Link className="nav-link" to="/">
              Home <i className="fa-solid fa-chevron-right"></i>Time Table
            </Link>
          </Col>
        </Row>
        <Row>
          <Col lg={4} className="mx-2 p-4" id="tabledata">
            {classList && classList.length > 0 ? (
              <Form.Group>
                <Form.Label
                  className="form-view-label"
                  htmlFor="formBasicClass"
                >
                  Class Name
                </Form.Label>
                <Form.Select
                  name="section_id"
                  value={sectionId}
                  onChange={onChangeClass}
                >
                  <option value="">-Select Class-</option>
                  {classList.map((cls, index) => (
                    <option key={index} value={cls.section_id}>
                      {cls.classname}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            ) : (
              <>
                <Form.Group>
                  <Form.Label
                    className="form-view-label"
                    htmlFor="formBasicClass"
                  >
                    Class Name
                  </Form.Label>
                  <Form.Select
                    name="section_id"
                    value={sectionId}
                    onChange={onChangeClass}
                  >
                    <option value="">-Select Class-</option>
                    {classList?.map((cls, index) => (
                      <option key={index} value={cls.section_id}>
                        {cls.classname}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </>
            )}
          </Col>
          <Col lg={4} className="mx-2 p-4">
            {teacherList && teacherList.length > 0 ? (
              <Form.Group>
                <Form.Label
                  className="form-view-label"
                  htmlFor="formBasicClass"
                >
                  Teacher Name
                </Form.Label>
                <Form.Select
                  name="teacher_id"
                  value={teacherId}
                  onChange={onChangeTeacher}
                >
                  <option value="">-Select Teacher-</option>
                  {teacherList.map((teacher, index) => (
                    <option key={index} value={teacher.id}>
                      {teacher.teachername}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            ) : (
              <>
                <Form.Group>
                  <Form.Label
                    className="form-view-label"
                    htmlFor="formBasicClass"
                  >
                    Teacher Name
                  </Form.Label>
                  <Form.Select
                    name="teacher_id"
                    value={teacherId}
                    onChange={onChangeTeacher}
                  >
                    <option value="">-Select Teacher-</option>
                    {teacherList.map((teacher, index) => (
                      <option key={index} value={teacher.id}>
                        {teacher.teachername}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </>
            )}
          </Col>
          {(teacherId || classId) && (
            <Col lg={3} className="mx-2 mt-5" style={{ textAlign: "right" }}>
              <Button className="mx-2" onClick={onDownloadPDF}>
                Download
              </Button>
            </Col>
          )}
        </Row>

        <Row>
          <Col className="mx-4">
            <div>
              {view === "teacher" ? (
                teacher ? (
                  <PrintTeacherTimetable
                    teacher={teacher}
                    tableRef={tableRef}
                  />
                ) : (
                  <>No Teacher Data Found!</>
                )
              ) : view === "class" ? (
                classTimeTable ? (
                  <PrintClassTimeTable
                    timeTableSlots={classTimeTable.timeSlotsResult}
                    tableRef={tableRef}
                  />
                ) : (
                  <>No Class Data Found!</>
                )
              ) : (
                <></>
              )}
            </div>
          </Col>
        </Row>
      </Row>
    </>
  );
}
